import { Routes, Route, Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/common/ProtectedRoute';
import { MainLayout } from './components/common/MainLayout';

// Pages
import LoginPage from './pages/Login';
import RequestRegistrationPage from './pages/RequestRegistration';
import CompleteRegistrationPage from './pages/CompleteRegistration';
import DashboardPage from './pages/Dashboard';
import AssetsPage from './pages/Assets/AssetsPage';
import AssetDetailPage from './pages/Assets/AssetDetailPage';
import DividendsPage from './pages/Dividends/DividendsPage';
import GoalsPage from './pages/Goals/GoalsPage';
import BuyCalendarPage from './pages/BuyCalendar/BuyCalendarPage';
import CryptoPage from './pages/Crypto/CryptoPage';
import FundsPage from './pages/Funds/FundsPage';
import AlertsPage from './pages/Alerts/AlertsPage';
import ImportPage from './pages/Import/ImportPage';
import TenantsPage from './pages/SuperAdmin/TenantsPage';
import SplashPage from './pages/SplashPage';
import { useAuth } from './context/AuthContext';

function SuperAdminRoute({ children }: { children: ReactNode }) {
  const { isSuperAdmin, isLoading } = useAuth();
  if (isLoading) return null;
  if (!isSuperAdmin) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RequestRegistrationPage />} />
        <Route path="/complete-registration" element={<CompleteRegistrationPage />} />

        {/* Splash — protegida mas sem MainLayout */}
        <Route path="/splash" element={
          <ProtectedRoute>
            <SplashPage />
          </ProtectedRoute>
        } />

        {/* Protected */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="assets" element={<AssetsPage />} />
          <Route path="assets/:id" element={<AssetDetailPage />} />
          <Route path="dividends" element={<DividendsPage />} />
          <Route path="goals" element={<GoalsPage />} />
          <Route path="buy-calendar" element={<BuyCalendarPage />} />
          <Route path="crypto" element={<CryptoPage />} />
          <Route path="funds" element={<FundsPage />} />
          <Route path="alerts" element={<AlertsPage />} />
          <Route path="import" element={<ImportPage />} />

          {/* Rotas SuperAdmin */}
          <Route
            path="admin/tenants"
            element={
              <SuperAdminRoute>
                <TenantsPage />
              </SuperAdminRoute>
            }
          />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </AuthProvider>
  );
}
